import { SVGProps } from "react";

export const FacebookIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="#91A4B7"
        d="M12 2a10 10 0 00-2 20v-7H8v-3h2v-2c0-3 2-4 4-4h2v3h-1l-1 1v2h2v3h-2v7a10 10 0 00-2-20z"
      />
    </svg>
  );
};

export const FacebookColorIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4550_18442)">
        <path
          d="M15.1169 16.0001C15.6046 16.0001 16 15.6047 16 15.117V0.883062C16 0.395312 15.6046 0 15.1169 0H0.883062C0.39525 0 0 0.395312 0 0.883062V15.117C0 15.6047 0.39525 16.0001 0.883062 16.0001H15.1169Z"
          fill="#1778F2"
        />
        <path
          d="M11.0398 15.9995V9.80345H13.1196L13.4309 7.38877H11.0398V5.84702C11.0398 5.14789 11.2339 4.67145 12.2365 4.67145L13.5152 4.67089V2.5112C13.2939 2.48177 12.5349 2.41602 11.6519 2.41602C9.80831 2.41602 8.54619 3.54133 8.54619 5.60795V7.38877H6.46106V9.80345H8.54619V15.9995H11.0398Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4550_18442">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FacebookCircleIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Facebook Icon</title>
      <circle cx="20" cy="20" r="20" fill="#E1E8F0" />
      <path
        d="M21.1645 27.4976V20.6676H23.4687L23.8112 17.9935H21.1645V16.2901C21.1645 15.5185 21.3795 14.9901 22.487 14.9901H23.8904V12.606C23.2076 12.5328 22.5212 12.4975 21.8345 12.5001C19.7979 12.5001 18.3995 13.7435 18.3995 16.026V17.9885H16.1104V20.6626H18.4045V27.4976H21.1645Z"
        fill="#91A4B7"
      />
    </svg>
  );
};

export const TwitterCircleIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Twitter Icon</title>
      <circle cx="20" cy="20" r="20" fill="#E1E8F0" />
      <path
        d="M26.3612 16.6646C26.372 16.8104 26.372 16.9554 26.372 17.1004C26.372 21.5379 22.9945 26.6513 16.822 26.6513C14.9203 26.6513 13.1537 26.1004 11.667 25.1438C11.937 25.1746 12.197 25.1854 12.4778 25.1854C13.9887 25.1891 15.4567 24.6839 16.6453 23.7513C15.9448 23.7386 15.2658 23.5075 14.703 23.0902C14.1402 22.673 13.7218 22.0904 13.5062 21.4238C13.7137 21.4546 13.922 21.4754 14.1403 21.4754C14.4412 21.4754 14.7437 21.4338 15.0245 21.3613C14.2643 21.2078 13.5807 20.7957 13.09 20.1952C12.5993 19.5946 12.3317 18.8426 12.3328 18.0671V18.0254C12.7803 18.2746 13.2995 18.4304 13.8495 18.4513C13.3887 18.1451 13.0109 17.7296 12.7498 17.2419C12.4886 16.7542 12.3523 16.2095 12.3528 15.6563C12.3528 15.0329 12.5187 14.4613 12.8095 13.9629C13.6529 15.0005 14.7049 15.8492 15.8973 16.4543C17.0896 17.0594 18.3958 17.4073 19.7312 17.4754C19.6795 17.2254 19.6478 16.9663 19.6478 16.7063C19.6476 16.2654 19.7343 15.8288 19.9029 15.4215C20.0715 15.0141 20.3187 14.644 20.6305 14.3323C20.9422 14.0205 21.3123 13.7733 21.7197 13.6047C22.127 13.4361 22.5636 13.3494 23.0045 13.3496C23.9712 13.3496 24.8437 13.7546 25.457 14.4096C26.2085 14.2643 26.9291 13.99 27.587 13.5988C27.3365 14.3745 26.8118 15.0322 26.1112 15.4488C26.7776 15.3728 27.429 15.1975 28.0437 14.9288C27.5846 15.598 27.0158 16.1849 26.3612 16.6646Z"
        fill="#91A4B7"
      />
    </svg>
  );
};

export const InstagramCircleIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Instagram Icon</title>
      <circle cx="20" cy="20" r="20" fill="#E1E8F0" />
      <path
        d="M20 14.1C16.75 14.1 14.1 16.75 14.1 20C14.1 23.25 16.75 25.9 20 25.9C23.25 25.9 25.9 23.25 25.9 20C25.9 16.75 23.25 14.1 20 14.1ZM20 24.1C17.74 24.1 15.9 22.26 15.9 20C15.9 17.74 17.74 15.9 20 15.9C22.26 15.9 24.1 17.74 24.1 20C24.1 22.26 22.26 24.1 20 24.1ZM26.2 13.8C26.2 14.68 25.48 15.4 24.6 15.4C23.72 15.4 23 14.68 23 13.8C23 12.92 23.72 12.2 24.6 12.2C25.48 12.2 26.2 12.92 26.2 13.8Z"
        fill="#91A4B7"
      />
      <path
        d="M24.8 11H15.2C12.88 11 11 12.88 11 15.2V24.8C11 27.12 12.88 29 15.2 29H24.8C27.12 29 29 27.12 29 24.8V15.2C29 12.88 27.12 11 24.8 11ZM27.2 24.8C27.2 26.12 26.12 27.2 24.8 27.2H15.2C13.88 27.2 12.8 26.12 12.8 24.8V15.2C12.8 13.88 13.88 12.8 15.2 12.8H24.8C26.12 12.8 27.2 13.88 27.2 15.2V24.8Z"
        fill="#91A4B7"
      />
    </svg>
  );
};

export const TikTokCircleIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>TikTok Icon</title>
      <circle cx="20" cy="20" r="20" fill="#E1E8F0" />
      <path
        d="M23.1 12.2C23.7 14.2 25.2 15.7 27.2 16.1V19.1C25.7 19.1 24.3 18.7 23.1 17.9V22.7C23.1 26 20.4 28.7 17.1 28.7C13.8 28.7 11.1 26 11.1 22.7C11.1 19.4 13.8 16.7 17.1 16.7C17.4 16.7 17.7 16.7 18 16.8V19.9C17.7 19.8 17.4 19.7 17.1 19.7C15.4 19.7 14 21.1 14 22.8C14 24.5 15.4 25.9 17.1 25.9C18.8 25.9 20.2 24.5 20.2 22.8V11H23.1V12.2Z"
        fill="#91A4B7"
      />
    </svg>
  );
};

export const LinkedinCircleIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Linkedin Icon</title>
      <circle cx="20" cy="20" r="20" fill="#E1E8F0" />
      <path
        d="M14.1524 15.9973C15.1594 15.9973 15.9758 15.1809 15.9758 14.1739C15.9758 13.1669 15.1594 12.3506 14.1524 12.3506C13.1454 12.3506 12.3291 13.1669 12.3291 14.1739C12.3291 15.1809 13.1454 15.9973 14.1524 15.9973Z"
        fill="#91A4B7"
      />
      <path
        d="M17.6974 17.3789V27.4947H20.8383V22.4922C20.8383 21.1722 21.0866 19.8939 22.7233 19.8939C24.3374 19.8939 24.3574 21.4031 24.3574 22.5756V27.4956H27.4999V21.9481C27.4999 19.2231 26.9133 17.1289 23.7283 17.1289C22.1991 17.1289 21.1741 17.9681 20.7549 18.7622H20.7124V17.3789H17.6974ZM12.5791 17.3789H15.7249V27.4947H12.5791V17.3789Z"
        fill="#91A4B7"
      />
    </svg>
  );
};

export const IntragramIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="##91A4B7"
        d="M12 7.4a4.6 4.6 0 100 9.2 4.6 4.6 0 000-9.2zm0 7.6a3 3 0 110-6 3 3 0 010 6zm4.8-6.7a1 1 0 100-2.2 1 1 0 000 2.2z"
      />
      <path
        fill="#FAFAFA"
        d="M20.5 6.1A4.6 4.6 0 0018 3.5a6.6 6.6 0 00-2.2-.4H8.3a6.6 6.6 0 00-2.2.4A4.6 4.6 0 003.5 6 6.6 6.6 0 003 8.3a64 64 0 00.4 9.6A4.6 4.6 0 006 20.5a6.6 6.6 0 002.2.5h7.4a6.6 6.6 0 002.2-.4 4.6 4.6 0 002.6-2.7c.3-.7.4-1.4.5-2.2V12 8.3a6.6 6.6 0 00-.5-2.2zm-1.2 9.5a5 5 0 01-.3 1.7 3 3 0 01-1.7 1.7 5 5 0 01-1.7.4H8.3a5 5 0 01-1.7-.4A3 3 0 015 17.3a5 5 0 01-.3-1.6 62.6 62.6 0 010-7.3A5 5 0 015 6.7 3 3 0 016.6 5a5 5 0 011.7-.4H15.6a5 5 0 011.7.4A3 3 0 0119 6.7a62.2 62.2 0 01.4 5.3v3.6z"
      />
    </svg>
  );
};
export const TwitterIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="#FAFAFA"
        d="M19.6 8v.5c0 5.3-4 11.5-11.4 11.5-2.3 0-4.4-.7-6.2-1.8h1a8 8 0 005-1.7 4 4 0 01-3.8-2.8H6a4 4 0 01-3.2-4 4 4 0 001.8.4 4 4 0 01-1.8-3.3c0-.8.2-1.4.6-2A11.5 11.5 0 0011.7 9l-.1-1a4 4 0 014-4 4 4 0 013 1.3 8 8 0 002.5-1 4 4 0 01-1.8 2.2 8 8 0 002.4-.6 8.6 8.6 0 01-2 2.1z"
      />
    </svg>
  );
};
export const GoogleIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.537 6.69498H14V6.66732H8.00004V9.33398H11.7677C11.218 10.8863 9.74104 12.0007 8.00004 12.0007C5.79104 12.0007 4.00004 10.2097 4.00004 8.00065C4.00004 5.79165 5.79104 4.00065 8.00004 4.00065C9.01971 4.00065 9.94737 4.38532 10.6537 5.01365L12.5394 3.12798C11.3487 2.01832 9.75604 1.33398 8.00004 1.33398C4.31837 1.33398 1.33337 4.31898 1.33337 8.00065C1.33337 11.6823 4.31837 14.6673 8.00004 14.6673C11.6817 14.6673 14.6667 11.6823 14.6667 8.00065C14.6667 7.55365 14.6207 7.11732 14.537 6.69498Z"
        fill="#FFC107"
      />
      <path
        d="M2.10193 4.89765L4.29226 6.50398C4.88493 5.03665 6.32026 4.00065 7.99993 4.00065C9.0196 4.00065 9.94726 4.38532 10.6536 5.01365L12.5393 3.12798C11.3486 2.01832 9.75593 1.33398 7.99993 1.33398C5.43926 1.33398 3.2186 2.77965 2.10193 4.89765Z"
        fill="#FF3D00"
      />
      <path
        d="M7.99994 14.6669C9.72194 14.6669 11.2866 14.0079 12.4696 12.9362L10.4063 11.1902C9.71446 11.7164 8.86909 12.0009 7.99994 12.0002C6.26594 12.0002 4.79361 10.8946 4.23894 9.35156L2.06494 11.0266C3.16827 13.1856 5.40894 14.6669 7.99994 14.6669Z"
        fill="#4CAF50"
      />
      <path
        d="M14.537 6.69368H14V6.66602H8V9.33268H11.7677C11.5047 10.0715 11.0311 10.7171 10.4053 11.1897L10.4063 11.189L12.4697 12.935C12.3237 13.0677 14.6667 11.3327 14.6667 7.99935C14.6667 7.55235 14.6207 7.11602 14.537 6.69368Z"
        fill="#1976D2"
      />
    </svg>
  );
};
